
import { FormControl, FormLabel, RadioGroup, FormControlLabel, Radio, useTheme } from "@mui/material";
import * as React from "react";

export type FilterMode = "unapproved" | "commented" | "none";

type AdminFilterProps = {
  isReader: boolean;
  value: FilterMode;                        // ← kommt vom Parent
  onChange: (value: FilterMode) => void;    // ← meldet Änderungen an den Parent
};

function AdminFilter({ isReader, value, onChange }: AdminFilterProps) {
  const theme = useTheme();
  if (isReader) return null;

  return (
    <FormControl
      component="fieldset"
      size="small"
      sx={{
        mb: 0,
        flexWrap: "wrap",
        alignItems: "center",
        border: "1px solid",
        borderColor: "warning.main",
        borderRadius: 2,
        p: 1,
        bgcolor: "background.paper",
      }}
    >
      <FormLabel component="legend" sx={{ color: value !== "none" ? "warning.main" : "text.primary" }}>
        Approval status
      </FormLabel>

      <RadioGroup
        row
        value={value}
        onChange={(_, v) => onChange(v as FilterMode)}
        name="exclusive-event-filter"
      >
        <FormControlLabel sx={{ color: theme.palette.text.primary }} value="none"       control={<Radio size="small" />} label="None" />
        <FormControlLabel sx={{ color: theme.palette.text.primary }} value="unapproved" control={<Radio size="small" />} label="Unapproved only" />
        <FormControlLabel sx={{ color: theme.palette.text.primary }} value="commented"  control={<Radio size="small" />} label="Commented only" />
      </RadioGroup>
    </FormControl>
  );
}

export default AdminFilter;
